import rootRoutings from './root';

export default [...rootRoutings];
